import { AutomatedVoiceAnswerDetection } from 'primary-schema';
import { z } from 'zod';
/** The payload Primary signals once Twilio reports a terminal call status. */
export const FlowAutomatedVoiceCallResultSchema = z.object({
    status: z.string(),
    answeredBy: z.enum(AutomatedVoiceAnswerDetection).optional(),
    durationSeconds: z.number().optional(),
    errorCode: z.string().optional(),
});
export const FlowAutomatedVoiceOutputSchema = FlowAutomatedVoiceCallResultSchema.partial().extend({
    callSid: z.string(),
    timedOut: z.boolean(),
});
//# sourceMappingURL=output.js.map